
import * as AlisonGUI from 'AlisonGUI';
import enviroment from '../enviroment.js'

export default (function () {
    return {
        version: AlisonGUI.version,
        serverToken: function({ client_id, client_secret, grant_type, scope}){
            const body = new FormData()
            body.append('client_id', client_id)
            body.append('client_secret', client_secret)
            body.append('grant_type', grant_type)
            body.append('scope', scope)
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', `${enviroment.alisonServerApiUrl}/oauth/token`);
                xhr.onload = () => {
                  resolve(JSON.parse(xhr.response));
                };
          /*
                xhr.onerror = xhr.ontimeout = () => {
                  reject({code: '408', response: 'Timeout'});
                };*/
                xhr.send(body);
            });
        },
        mount: function(config){
            return AlisonGUI.mount(config)
        },
        unmount: function(){
            AlisonGUI.unmount()
        },
    }
})();
